import { render, staticRenderFns } from "./OtherMovements.vue?vue&type=template&id=0c984ac5&scoped=true&"
import script from "./OtherMovements.vue?vue&type=script&lang=js&"
export * from "./OtherMovements.vue?vue&type=script&lang=js&"
import style0 from "./OtherMovements.vue?vue&type=style&index=0&id=0c984ac5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c984ac5",
  null
  
)

export default component.exports